export default __webpack_public_path__ + "static/2-c6001dad1faf6f775601516546b0236b.jpeg";